import React from 'react'
import { FaStar } from "react-icons/fa"

function ReviewSlide({ image, name, review, company, time }) {
    return (
        <div className="review-body p-4 d-flex justify-content-center align-items-center shadow">
            <div className="card text-center">
                <div className="card-header">
                    <img src={image} alt="" className="img-fluid review-image mx-auto" />
                    <p className="reviewer-name mt-3 mb-1">{name}</p>
                </div>
                <div className="card-body">
                    <div className="reviewer-rating mb-2">
                        <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
                    </div>
                    <div className="reviewer-message">
                        <p className="review mb-0">"{review}"</p>
                    </div>
                </div>
                {/* <div className="reviewer-company card-footer d-flex justify-content-center align-items-center">
                    <img src={company} alt="" className="img-fluid" />
                    <span className="review-time ms-2">{time}</span>
                </div> */}
            </div>
        </div>
    )
}
export default ReviewSlide